import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=5f8e0d62"
import script from "./Tournament.vue?vue&type=script&lang=js"
export * from "./Tournament.vue?vue&type=script&lang=js"
import style0 from "./Tournament.vue?vue&type=style&index=0&id=5f8e0d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports